export default {
    computed: {
        basePath:{
            get(){
                return this.$store.getters.getBasePath;
            }
        },
        cdnPath:{
            get(){
                return this.$store.getters.getCdnPath;
            }
        },
    },
};